class KeyCodes {
}
KeyCodes.ARROW_LEFT = 37;
KeyCodes.ARROW_UP = 38;
KeyCodes.ARROW_RIGHT = 39;
KeyCodes.ARROW_DOWN = 40;
KeyCodes.ENTER = 13;
KeyCodes.TAB = 9;
KeyCodes.ESCAPE = 27;
KeyCodes.SPACEBAR = 32;

export { KeyCodes as K };
